export function isQueryObjectMatch(currentQuery: any, newQuery: any) {
  if (currentQuery !== null && currentQuery !== undefined) {
    if (currentQuery.q !== newQuery.q) {
      return false;
    }
    return true;
  } else {
    return false;
  }
}
